import { render, staticRenderFns } from "./goods-audit.vue?vue&type=template&id=4e045e28&scoped=true&"
import script from "./goods-audit.vue?vue&type=script&lang=js&"
export * from "./goods-audit.vue?vue&type=script&lang=js&"
import style0 from "./goods-audit.vue?vue&type=style&index=0&id=4e045e28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e045e28",
  null
  
)

export default component.exports